import { useContext } from "react";

import { useLocation, useNavigate } from "react-router-dom";
import Select from "@components/ui-components/select";
import { UserContext } from "@context/user";

// Lets a publisher-workspace session switch which publisher account it's acting as —
// mirrors the Nook Pay Hub reference's topbar Select (persona === "publisher").
const PublisherSwitcher = () => {
    const { publishers, activePublisherId, setActivePublisherId } = useContext(UserContext);
    const { pathname } = useLocation();
    const navigate = useNavigate();

    if (!publishers.length) return null;

    const handleChange = (nextId) => {
        setActivePublisherId(nextId);
        navigate(activePublisherId ? pathname.replace(activePublisherId, nextId) : `/publisher/${nextId}/overview`);
    };

    return (
        <Select
            id="publisher-switcher"
            size="sm"
            value={activePublisherId || ""}
            onChange={handleChange}
            options={publishers.map((publisher) => ({ value: publisher.id, label: publisher.name }))} />
    );
};

export default PublisherSwitcher;
